// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"5f09b4e0","939":"7c1f474c"}[chunkId] + ".chunk.css";
};